import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { AdminDashboardPage } from "~pages/Admin/AdminDashboard/AdminDashboardPage";
import { AdminFixturePage } from "~pages/Admin/AdminFixture/AdminFixturePage";
import { AdminSeasonPage } from "~pages/Admin/AdminSeason/AdminSeasonPage";
import { ForbiddenPage } from "~pages/Shared/Errors/ForbiddenPage";
import { NotFoundPage } from "~pages/Shared/Errors/NotFoundPage";
import { HealthPage } from "~pages/Shared/Health/HealthPage.tsx";
import { LogoutRedirectPage } from "~pages/Shared/Logout/LogoutRedirectPage";
import { PrivacyPage } from "~pages/Shared/Privacy/PrivacyPage";
import { Root } from "~pages/Shared/Root/Root";
import { SelectCustomerPage } from "~pages/StartupWizard/SelectCustomerPage";
import { SelectEntityPage } from "~pages/StartupWizard/SelectEntityPage";
import { SelectOrganizationPage } from "~pages/StartupWizard/SelectOrganizationPage";
import { SelectRolePage } from "~pages/StartupWizard/SelectRolePage";
import { DashboardPage } from "~pages/TeamManager/Dashboard/DashboardPage";
import { EntityEditPage } from "~pages/TeamManager/Entities/EntityEditPage";
import { FixturePage } from "~pages/TeamManager/Fixtures/FixturePage";
import { FixturesPage } from "~pages/TeamManager/Fixtures/FixturesPage";
import { SeasonPage } from "~pages/TeamManager/Seasons/SeasonPage";

const router = createBrowserRouter([
  {
    path: "403",
    element: <ForbiddenPage />,
  },
  {
    path: "404",
    element: <NotFoundPage />,
  },
  {
    path: "health",
    element: <HealthPage />,
  },
  {
    path: "privacy-notice",
    element: <PrivacyPage />,
  },
  {
    path: "logout",
    element: <LogoutRedirectPage />,
  },
  {
    path: "/",
    element: <Root />,
    children: [
      // Startup wizard
      {
        path: "/",
        element: <SelectCustomerPage />,
      },
      {
        path: ":customerId",
        element: <SelectOrganizationPage />,
      },
      {
        path: ":customerId/:sport/:organizationId/role",
        element: <SelectRolePage />,
      },
      {
        path: ":customerId/:sport/:organizationId/entities",
        element: <SelectEntityPage />,
      },

      // Team manager pages
      {
        path: ":customerId/:sport/:organizationId/entities/:entityId",
        element: <DashboardPage />,
      },
      {
        path: ":customerId/:sport/:organizationId/entities/:entityId/edit",
        element: <EntityEditPage />,
      },
      {
        path: ":customerId/:sport/:organizationId/entities/:entityId/seasons/:seasonId/fixtures",
        element: <FixturesPage />,
      },
      {
        path: ":customerId/:sport/:organizationId/entities/:entityId/seasons/:seasonId/fixtures/:fixtureId",
        element: <FixturePage />,
      },
      {
        path: ":customerId/:sport/:organizationId/entities/:entityId/seasons/:seasonId",
        element: <SeasonPage />,
      },
      // Admin pages
      {
        path: ":customerId/:sport/:organizationId/admin",
        element: <AdminDashboardPage />,
      },
      {
        path: ":customerId/:sport/:organizationId/admin/entities/:entityId/seasons/:seasonId",
        element: <AdminSeasonPage />,
      },
      {
        path: ":customerId/:sport/:organizationId/admin/entities/:entityId/seasons/:seasonId/fixtures/:fixtureId",
        element: <AdminFixturePage />,
      },
    ],
  },
]);

const Router = () => {
  return <RouterProvider router={router} />;
};

export default Router;
